import {gql} from '@apollo/client'

import {CART_ITEM_FRAGMENT} from '../fragments/vaultExtension'

export const VAULT_EXTENSION = gql`
  ${CART_ITEM_FRAGMENT}
  query vaultExtension($everplanId: Int!) {
    vaultExtension(everplanId: $everplanId) {
      id
      packageName
      services {...CartItemFragment}
      merchandise {...CartItemFragment}
      essentials {...CartItemFragment}
    }
  }
`
